import { render, staticRenderFns } from "./ExtraPassportDetail.vue?vue&type=template&id=4210da6a&scoped=true&"
import script from "./ExtraPassportDetail.vue?vue&type=script&lang=js&"
export * from "./ExtraPassportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210da6a",
  null
  
)

export default component.exports